'use client';

import { useRef } from 'react';
import { X } from 'lucide-react';
import { Portal } from './portal';

export const ReviewsModal: React.FC<{
  triggerLabel: string;
  title?: string;
  note?: string;
  children: React.ReactNode;
}> = ({ triggerLabel, title, note, children }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  return (
    <>
      <button
        type="button"
        className="btn btn-outline"
        onClick={() => dialogRef.current?.showModal()}
      >
        {triggerLabel}
      </button>

      <Portal>
        <dialog ref={dialogRef} className="modal" aria-label={title ?? 'Reviews'}>
          <div className="modal-box max-w-3xl max-h-[85vh] overflow-y-auto bg-base-100">
            <form method="dialog">
              <button
                className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2 z-10"
                aria-label="Close"
              >
                <X />
              </button>
            </form>

            {title ? <h2 className="text-2xl font-bold mb-1">{title}</h2> : null}
            {note ? <p className="text-sm text-base-content/70 mb-6">{note}</p> : null}

            {children}
          </div>

          <form method="dialog" className="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>
      </Portal>
    </>
  );
};
